module.exports = __webpack_public_path__ + "static/doc-illustration-60081c5b72e96ef0f99a9bf237ca786b.png";